import { render } from "./agent-first-response.vue?vue&type=template&id=7b1de9c8"
import script from "./agent-first-response.vue?vue&type=script&lang=js"
export * from "./agent-first-response.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__